// extracted by mini-css-extract-plugin
module.exports = {"card":"messageCard_card__fUMsA","mcard":"messageCard_mcard__2y19o"};